app.controller('demoLoginController', [
  '$scope',
  '$state',
  '$rootScope',
  'userService',
  'storageService',
  '$location',
  'initService',
  '$http',
  function($scope, $state, $rootScope, userService, storageService, $location, initService, $http) {
    /** **************************** */
    /** ******** VARIABLES ********* */
    /** **************************** */

    /** ********************************* */
    /** ******** INIT FUNCTIONS ********* */
    /** ********************************* */

    document.cookie = `token=${$location.search().token}`;
    $http.defaults.headers.common.Authorization = $location.search().token;

    storageService.validateToken($location.search().token, 'login', false).then(() =>
      userService.getUserInformation().then(() => {
        if ($rootScope.decodedToken && !window.NO_REDIRECT) {
          window.location.href = `${$rootScope.decodedToken.org.dashboard_url}/buildings`;
        } else {
          window.location.href = '/buildings';
        }
      })
    );

    /** *************************** */
    /** ******** Watchers ********* */
    /** *************************** */

    /** ********************************** */
    /** ******** SCOPE VARIABLES ********* */
    /** ********************************** */

    /** ********************************** */
    /** ******** SCOPE FUNCTIONS ********* */
    /** ********************************** */

    /** **************************** */
    /** ******** FUNCTIONS ********* */
    /** **************************** */
  }
]);
